import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00031 } from '../../../../P00031';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';

@Component({
  selector: 'app-p00045-card-link-status',
  templateUrl: './p00045-card-link-status.component.html',
  styleUrls: ['./p00045-card-link-status.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P00045CardLinkStatusComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P00045.card.state.link.status.off',
        icon: 'fa-kit fa-picto-cloudnosignal',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00045.card.state.link.status.on',
        icon: 'fa-kit fa-picto-connect',
        color: 'color-green',
        status: 'active',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.LINK,
      FunctionOnglet.STATUS,
      this.translateService.instant('P00045.card.state.link.title'),
    );
  }
}
